import React, { useState } from "react"
import {
  Form,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback,
} from "reactstrap"
import { useNavigate } from "react-router-dom"

const ColdCallForm = ({ formData, setFormData, onSubmit }) => {
  const navigate = useNavigate()
  const [errors, setErrors] = useState({})

  const handleChange = e => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
    // ✅ Clear error on change
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: "" }))
    }
  }

  const validate = () => {
    const newErrors = {}

    if (!formData.name?.trim()) {
      newErrors.name = "Name is required."
    }

    // if (!formData.email?.trim()) {
    //   newErrors.email = "Email is required."
    // } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    //   newErrors.email = "Enter a valid email address."
    // }

    if (!formData.type) {
      newErrors.type = "Please select a type."
    }

    if (!formData.date) {
      newErrors.date = "Date is required."
    }

    if (!formData.machineName?.trim()) {
      newErrors.machineName = "Machine name is required."
    }

    if (!formData.area?.trim()) {
      newErrors.area = "Area is required."
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0 // true = valid
  }

  const handleSubmit = () => {
    if (validate()) {
      onSubmit()
    }
  }

  return (
    <Form>
      <Row>
        {/* Name */}
        <Col md={4}>
          <FormGroup>
            <Label>
              Name <span className="text-danger">*</span>
            </Label>
            <Input
              name="name"
              value={formData.name || ""}
              onChange={handleChange}
              placeholder="Enter name"
              className="rounded-4"
              invalid={!!errors.name}
            />
            <FormFeedback>{errors.name}</FormFeedback>
          </FormGroup>
        </Col>

        {/* Email */}
        {/* <Col md={4}>
          <FormGroup>
            <Label>
              Email <span className="text-danger">*</span>
            </Label>
            <Input
              name="email"
              type="email"
              value={formData.email || ""}
              onChange={handleChange}
              placeholder="Enter email"
              className="rounded-4"
              invalid={!!errors.email}
            />
            <FormFeedback>{errors.email}</FormFeedback>
          </FormGroup>
        </Col> */}

        {/* Type */}
        <Col md={4}>
          <FormGroup>
            <Label>
              Type <span className="text-danger">*</span>
            </Label>
            <Input
              type="select"
              name="type"
              value={formData.type || ""}
              onChange={handleChange}
              className="rounded-4"
              invalid={!!errors.type}
            >
              <option value="">-- Select Type --</option>
              <option value="calling">Calling</option>
              <option value="visit">Visit</option>
            </Input>
            <FormFeedback>{errors.type}</FormFeedback>
          </FormGroup>
        </Col>

        {/* Date */}
        <Col md={4}>
          <FormGroup>
            <Label>
              Date <span className="text-danger">*</span>
            </Label>
            <Input
              type="date"
              name="date"
              value={formData.date || ""}
              onChange={handleChange}
              className="rounded-4"
              invalid={!!errors.date}
            />
            <FormFeedback>{errors.date}</FormFeedback>
          </FormGroup>
        </Col>

        {/* Area */}
        <Col md={4}>
          <FormGroup>
            <Label>
              Area <span className="text-danger">*</span>
            </Label>
            <Input
              name="area"
              value={formData.area || ""}
              onChange={handleChange}
              placeholder="Enter area"
              className="rounded-4"
              invalid={!!errors.area}
            />
            <FormFeedback>{errors.area}</FormFeedback>
          </FormGroup>
        </Col>

        {/* Machine Name */}
        <Col md={8}>
          <FormGroup>
            <Label>
              Discussion <span className="text-danger">*</span>
            </Label>
            <Input
              name="machineName"
              value={formData.machineName || ""}
              onChange={handleChange}
              placeholder="Enter Discussion"
              className="rounded-4"
              invalid={!!errors.machineName}
            />
            <FormFeedback>{errors.machineName}</FormFeedback>
          </FormGroup>
        </Col>
      </Row>

      <div className="mt-4">
        <Button color="primary" onClick={handleSubmit}>
          Save
        </Button>
        <Button color="danger" className="ms-2" onClick={() => navigate(-1)}>
          Cancel
        </Button>
      </div>
    </Form>
  )
}

export default ColdCallForm
